import {
  useContext, useState, useEffect, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';

import axios from 'axios';

import { Input } from '@tourmalinecore/react-tc-ui-kit';
import AuthForm from './components/AuthForm/AuthForm';

import { authService } from '../../common/services/authService';
import { API_ROOT } from '../../common/config/config';

import './AuthPage.css';

export default function AuthPage() {
  const [isAuthenticated] = useContext(authService.AuthContext);
  const history = useHistory();

  const loginRef = useRef();
  const passRef = useRef();

  const [formData, setFormData] = useState({
    login: '',
    password: '',
  });

  const [triedToSubmit, setTriedToSubmit] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => {
    resetAndFocus();

    if (isAuthenticated) {
      history.push('/');
    }
  }, [isAuthenticated]);

  return (
    <div className="auth-page">
      <AuthForm
        onSubmit={handleFormSubmit}
        errorMessages={errorMessages}
      >
        <Input
          id="login"
          className="auth-page__input"
          type="text"
          label="Login"
          value={formData.login}
          isInvalid={!formData.login && triedToSubmit}
          inputRef={loginRef}
          validationMessages={['Login should be filled']}
          isMessagesAbsolute
          onChange={(e) => setFormData({ ...formData, login: e.target.value })}
        />

        <Input
          id="password"
          className="auth-page__input"
          type="password"
          label="Password"
          value={formData.password}
          isInvalid={!formData.password && triedToSubmit}
          inputRef={passRef}
          validationMessages={['Password should be filled']}
          isMessagesAbsolute
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        />
      </AuthForm>
    </div>
  );

  function handleFormSubmit(e) {
    const {
      login,
      password,
    } = formData;

    e.preventDefault();

    if (login && password) {
      setErrorMessages([]);
    }

    setTriedToSubmit(true);

    axios.post(`${API_ROOT}/auth/login`, {
      login,
      password,
    })
      .then((response) => {
        authService.setLoggedIn(response.data);
      })
      .catch(() => {
        setErrorMessages(['Invalid password or login']);
      });
  }

  function resetAndFocus() {
    loginRef.current.focus();
  }
}
